import React from "react"

import { ProjectPageProjectSidebar } from "pages/project-page/sidebar/project/ProjectPageProjectSidebar"

import { useSharedProjectPageProjectSidebarModel } from "../hooks/useSharedProjectPageProjectSidebarModel"

export const SharedProjectPageProjectSidebarConnector = React.memo(
  ({ projectID }: { projectID: string }) => (
    <ProjectPageProjectSidebar
      id="shared-project-page-project-sidebar"
      {...useSharedProjectPageProjectSidebarModel({ projectID })}
      hideControls
    />
  )
)
